import React from 'react'
import { Modal, NotificationInline, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { CloseIcon, CommerceIcon } from 'assets/icons'
import ModalRoute from 'src/components/utils/ModalRoute'
import { useOrganization } from 'src/graphql/hooks'
import IntegrationStripeListItemRow from '~/components/IntegrationStripeListItemRow'
import DiscountCreate from './DiscountCreate'

const CommerceEditor = ({ onCloseButtonClick }) => {
   const match = useRouteMatch()
   const location = useLocation()
   const { organization } = useOrganization()

   // Note: This path originates from the API
   const stripeJustConnected = location.pathname.endsWith('/connect/stripe/success')

   return (
      <View
         borderRadius="3px"
         style={{ overflow: 'hidden' }}
         float="left"
         width="100%"
         height="100%"
         scroll="on[a-b]">
         <View
            position="absolute"
            top="0px"
            right="0px"
            width="100%[a-b] calc(100% - 240px)[c-f]"
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            float="left"
            height="60px"
            padding="0px 15px">
            <View
               display="flex"
               justifyContent="flex-end"
               alignItems="center"
               onClick={onCloseButtonClick}>
               <CloseIcon width="24px" height="24px" />
            </View>
         </View>
         <View
            display="flex"
            float="left"
            width="100%[a-b] 240px[c-f]"
            height="100%[c-f]"
            borderBottom="1px solid #eee[a-b]"
            borderRight="1px solid #eee[c-f]"
            padding="20px[a-b] 25px[c-f]">
            <View>
               <View
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="35px"
                  height="35px"
                  borderRadius="50%"
                  backgroundColor="#000">
                  <CommerceIcon
                     width="16px"
                     height="16px"
                     strokeWidth="2px"
                     color="#fff"
                  />
               </View>
               <Spacer size="2" />
               <Text
                  size="5"
                  color="#000"
                  weight="medium">
                  Commerce & Discounts
               </Text>
               <Spacer size="2" />
               <Text size="2" color="#777">
                  {'Easily charge and accept payments for event tickets by connecting your Stripe account.'}
               </Text>
            </View>
         </View>
         <View
            float="left"
            width="100%[a-b] calc(100% - 240px)[c-f]"
            height="100%[c-f]">
            <View
               float="left"
               width="100%"
               height="calc(100% - 60px)"
               marginTop="60px[c-f]"
               scroll="on">
               {stripeJustConnected && (
                  <NotificationInline
                     borderRadius="0px"
                     iconSize="30px"
                     iconSpacing="24px"
                     textSize="1.5"
                     type="success"
                     title="Success!"
                     message="Your Stripe account was connected successfully"
                     paddingHorizontal="24px"
                  />
               )}
               {!organization.commerceEnabled && (
                  <NotificationInline
                     borderRadius="0px"
                     backgroundColor="rgba(247, 183, 124, 0.15)"
                     iconColor="#f7b77c"
                     iconSize="30px"
                     textColor="#333"
                     type="info"
                     title="Please note:"
                     message="You must connect the Stripe payment gateway to accept payments"
                     paddingHorizontal="24px"
                     iconSpacing="24px"
                  />
               )}
               <IntegrationStripeListItemRow />
               {/*
                  TODO: This has been commented out for future use.
                  It has never actually been active
                  See PR #682
               <View
                  width="100%"
                  padding="12px 0px">
                  <Spacer size="3" />
                  <Text size="0.9" weight="bold" color="#000" transform="uppercase">
                     Discounts
                  </Text>
               </View>
               <View
                  width="100%"
                  borderRadius="6px"
                  backgroundColor="#fff">
                  <View textAlign="center" padding="30px">
                     <Text size="1.5" color="#888">
                        No discounts have been created yet
                     </Text>
                  </View>
               </View>
               */}
            </View>
         </View>
         <ModalRoute path={`${match.url}/discount-create`}>
            {({ open, onCloseComplete, onCloseTrigger }) => (
               <Modal
                  borderRadius="5px"
                  width="100%[a-b] 330px[c-f]"
                  height="100%[a-b] auto[c-f]"
                  onCloseComplete={onCloseComplete}
                  onCloseTrigger={onCloseTrigger}
                  open={open}>
                  <DiscountCreate
                     onCloseButtonClick={onCloseTrigger}
                     onSave={onCloseTrigger}
                  />
               </Modal>
            )}
         </ModalRoute>
      </View>
   )
}

CommerceEditor.propTypes = {
   onCloseButtonClick: PropTypes.func.isRequired
}

export default CommerceEditor
